import React from "react";
import assign from "lodash/assign";
import BaseOverlay from "./base.jsx";
import Checkout from "../partials/checkout.jsx";
import InjectedTenantHTML from "../partials/injected-tenant-html.jsx";
import { Navigation } from "react-router";

import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";
import OrderStore from "../../stores/OrderStore";
import PassStore from "../../stores/PassStore";
import PersonStore from "../../stores/PersonStore";
import OrderActions from "../../actions/OrderActions";
import PassActions from "../../actions/PassActions";
import CouponActions from "../../actions/CouponActions";

export default statics(
  {
    willTransitionTo({ params, location }, replace, callback) {
      PassActions.fetchPassTypes.defer();

      if (
        location.action === "POP" &&
        OrderStore.getState().orderData.subitems &&
        OrderStore.getState().orderData.subitems.length
      ) {
        // If navigating back, don't reset order flow
        return callback();
      }

      OrderActions.newOrderFlow();

      let passBucket = PassStore.getPassTypeByCode(params.code);
      OrderActions.updateCurrentOrder({
        return: location.query.return,
        pass_code: params.code,
        pass: location.query.pass,
        gift: location.query.gift ? true : undefined,
        subitems: passBucket
          ? [
              {
                pass_bucket: passBucket.id,
                quantity: +location.query.quantity || 1
              }
            ].concat(
              TENANT.donate_inline_order_prompt
                ? [{ inline_donation: true }]
                : []
            )
          : []
      });
      CouponActions.reset();

      callback();
    }
  },

  @connectToStores
  class BuyPassesOverlay extends React.Component {
    constructor(props) {
      super(props);
      this.cancel = this.cancel.bind(this);
    }

    static getStores() {
      return [OrderStore, PassStore, PersonStore];
    }

    static get contextTypes() {
      return {
        router: React.PropTypes.object.isRequired,
        tenant: React.PropTypes.object.isRequired,
        appSettings: React.PropTypes.object.isRequired
      };
    }

    static getPropsFromStores() {
      var state = OrderStore.getState();
      state.getOrderById = OrderStore.getOrderById;
      state.getPassTypeByCode = PassStore.getPassTypeByCode;
      state.isLoggedIn = PersonStore.getState().isLoggedIn;
      state.person = PersonStore.getState().details;
      state.guestCheckoutActiveEmail =
        PersonStore.getState().guestCheckoutActiveEmail;
      return state;
    }

    componentWillReceiveProps(newProps) {
      if (
        newProps.orderData &&
        (!newProps.orderData.subitems ||
          newProps.orderData.subitems.length === 0)
      ) {
        let passType = newProps.getPassTypeByCode(newProps.orderData.pass_code);
        if (passType) {
          OrderActions.updateCurrentOrder.defer({
            subitems: [
              {
                pass_bucket: passType.id,
                quantity: +newProps.location.query.quantity || 1
              }
            ].concat(
              TENANT.donate_inline_order_prompt
                ? [{ inline_donation: true }]
                : []
            )
          });
        }
      }
    }

    cancel() {
      if (!(this.props.orderInProgress || this.props.orderSuccess)) {
        if (
          this.props.location.state &&
          this.props.location.state.fromMainListing
        ) {
          this.context.router.goBack();
        } else {
          this.context.router.push(
            `/${this.context.tenant.passes_url_pathname}/buy`
          );
        }
      }
    }

    submit() {
      OrderActions.submitOrder.defer();
    }

    render() {
      const pass = this.props.getPassTypeByCode(this.props.orderData.pass_code);
      if (!pass) {
        return null;
      }

      return (
        <BaseOverlay
          onRequestClose={this.cancel}
          className={this.props.className}
          zIndex={2000}
        >
          {pass.sales_disabled_unless_pass_rule &&
          !this.props.orderData.pass ? (
            <div style={{ fontSize: "12pt", textAlign: "center" }}>
              You must have an eligible {this.context.tenant.memberships_enabled ? this.context.tenant.display_membership : this.context.tenant.display_pass} in
              your account in order to purchase the "{pass.name}"{" "}
              {this.context.tenant.memberships_enabled ? this.context.tenant.display_membership : this.context.tenant.display_pass}. Please ensure that you are
              logged in to an account containing an eligible{" "}
              {this.context.tenant.memberships_enabled ? this.context.tenant.display_membership : this.context.tenant.display_pass}, then try again.
            </div>
          ) : this.context.appSettings.mode === "box_office_only" ? (
            <div style={{ fontSize: "11pt" }}>
              <InjectedTenantHTML
                content={this.context.tenant.box_office_only_message}
              />
            </div>
          ) : (
            <Checkout
              orderInProgress={this.props.orderInProgress}
              orderSuccess={this.props.orderSuccess}
              orderErrorMessage={this.props.orderErrorMessage}
              orderData={this.props.orderData}
              orderShowDonateInterstitial={
                this.props.orderShowDonateInterstitial
              }
              updateCurrentOrder={OrderActions.updateCurrentOrder}
              completedOrder={this.props.getOrderById(
                this.props.completedOrderId
              )}
              person={this.props.person}
              usingPass={this.props.orderData.pass}
              isLoggedIn={this.props.isLoggedIn}
              guestCheckoutActiveEmail={this.props.guestCheckoutActiveEmail}
              pass={pass}
              initialCouponCode={this.props.location.query.discount_code}
              showGiftEntry={pass && pass.gift_allowed}
              cancel={this.cancel}
              submit={this.submit}
            />
          )}
        </BaseOverlay>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/app/components/overlays/buy-passes.jsx